export function PageHeader({
  heading,
  children
}: React.PropsWithChildren & { heading: string }) {
  return (
    <div className="my-4 md:flex md:items-center md:justify-between">
      <div className="min-w-0 flex-1">
        <h3 className="text-lg font-medium leading-7 sm:truncate sm:tracking-tight">
          {heading}
        </h3>
        <h3 className="sr-only">{heading}</h3>
      </div>
      <div className="mt-4 flex md:mt-0 md:ml-4">
        {children}
      </div>
    </div>
  )
}
